class Compatibility {
    constructor(options) {
        var defaults = {
            selector: '#compatibility'
        };
        this.params = Object.assign({}, defaults, options || {});
        this.el = document.querySelector(this.params.selector);
        this.signs = ['ΚΡΙΟΣ', 'ΤΑΥΡΟΣ', 'ΔΙΔΥΜΟΙ', 'ΚΑΡΚΙΝΟΣ', 'ΛΕΩΝ', 'ΠΑΡΘΕΝΟΣ', 'ΖΥΓΟΣ', 'ΣΚΟΡΠΙΟΣ', 'ΤΟΞΟΤΗΣ', 'ΑΙΓΟΚΕΡΩΣ', 'ΥΔΡΟΧΟΟΣ', 'ΙΧΘΥΕΣ'];
        this.addEvents();
    }

    addEvents() {

        // Form submit event
        document.querySelector('form').addEventListener('submit', (event) => {
            event.preventDefault();
            this.loadCompatibilityResults();
        });

        // Arrow up event
        var upButtons = document.querySelectorAll('[data-role="sign-arrow-up"]');
        for (let index = 0; index < upButtons.length; index++) {
            upButtons[index].addEventListener('click', (event) => {
                event.preventDefault();
                var parent = event.target.closest('[data-role="sign-selector"]');
                var current = parseInt(parent.querySelector('input[type="hidden"]').value);
                var next;
                if (current === 11) {
                    next = 0;
                } else {
                    next = current + 1;
                }
                this.renderSign(parent, next);
            });
        }


        // Arrow down event
        var downButtons = document.querySelectorAll('[data-role="sign-arrow-down"]');
        for (let index = 0; index < downButtons.length; index++) {
            downButtons[index].addEventListener('click', (event) => {
                event.preventDefault();
                var parent = event.target.closest('[data-role="sign-selector"]');
                var current = parseInt(parent.querySelector('input[type="hidden"]').value);
                var previous;
                if (current === 0) {
                    previous = 11;
                } else {
                    previous = current - 1;
                }
                this.renderSign(parent, previous);
            });
        }

    }

    loadCompatibilityResults() {
        var sign1 = parseInt(this.el.querySelector('input[name="sign1"]').value) + 1;
        var sign2 = parseInt(this.el.querySelector('input[name="sign2"]').value) + 1;
        window.location = window.location.origin + "/erotikh-astrologia/apotelesmata-synastrias?sign1=" + sign1 + '&sign2=' + sign2;
    }

    renderSign(container, value) {
        var name = container.querySelector('[data-role="sign-name"]');
        var input = container.querySelector('input[type="hidden"]');
        var icon = container.querySelector('[data-role="sign-icon"]');
        name.innerText = this.signs[value];
        input.value = value;
        icon.removeAttribute('class');
        icon.classList.add('sign-icon-' + value);
    }


}

export {
    Compatibility as
        default
};
